<template>
  <div class="page-work-with-us site-section-v site-container">
    <header class="text-center">
      <h2 class="text-orange">
        Envie seu Curriculum à Crivelli Advogados Associados
      </h2>
      <p class="text-grey-dark">
        Caso não haja aproveitamento imediato, manteremos suas informações em
        nossa base de dados para contato futuro.
      </p>
    </header>
    <form
      @submit.prevent="submit"
      ref="formContact"
      id="form-contact"
      :key="componentKey"
    >
      <slot name="form-top"></slot>
      <field
        helper-text="Nome Completo"
        has-border
        is-small
        placeholder="Nome"
        :input="{ type: 'text', name: 'Nome', required: 'required' }"
      />

      <field
        helper-text="email@email.com"
        has-border
        is-small
        placeholder="E-mail"
        :input="{ type: 'email', name: 'Email', required: 'required' }"
      />

      <field
        helper-text="(11) 2345-6789"
        has-border
        is-small
        placeholder="Telefone"
        :input="{ type: 'tel', name: 'Telefone', required: 'required' }"
      />
      <field has-border is-small placeholder="Tipo de Vaga">
        <template v-slot:default="{ changeFocus }">
          <select
            required
            v-model="Vaga"
            @focus="changeFocus(true)"
            name="Vaga"
          >
            <option value="Administrativo">Administrativo</option>
            <option value="Advogado">Advogado</option>
            <option value="Estagiário">Estagiário</option>
          </select>
        </template>
      </field>

      <field has-border is-small>
        <template>
          <input required name="File" type="file" ref="file"/>
        </template>
      </field>
      <field has-border is-small placeholder="Mensagem">
        <template v-slot:default="{ changeFocus }">
          <textarea
            required
            name="Mensagem"
            @blur="changeFocus(false)"
            @focus="changeFocus(true)"
          ></textarea>
        </template>
      </field>
      <p class="text-center">
        <button type="submit" class="button button-orange">ENVIAR</button>
      </p>
    </form>

    <modal :active.sync="modalContactIsOpen">
      <div class="text-center">
        <h3>Sua mensagem foi enviada com sucesso!</h3>
      </div>
    </modal>
  </div>
</template>

<script>
import Field from "../../components/Field.vue";
import Modal from "@/components/Modal";
import api from "../../services/api";
// import qs from "querystring";

export default {
  components: { Field, Modal },

  data() {
    return {
      modalContactIsOpen: false,
      componentKey: 0,
      form: {
        file: null,
      },
    };
  },
  methods: {
    async submit() {

      try {
        var nome = document.querySelector('[name="Nome"]').value;
        var email = document.querySelector('[name="Email"]').value;
        var telefone = document.querySelector('[name="Telefone"]').value;
        var mensagem = document.querySelector('[name="Mensagem"]').value;
        var vaga = document.querySelector('[name="Vaga"]').value;
        let arquivos = this.$refs.file.files;
        
        const formData = new FormData();
        formData.append("Nome", nome);
        formData.append("Email", email);
        formData.append("Telefone", telefone);
        formData.append("Mensagem", mensagem);
        formData.append("Vaga", vaga);
        formData.append("File", arquivos[0]);
    
    console.log("body", formData);
        await api
          .post("work-us", formData)
          .then(() => {
            this.modalContactIsOpen = true;
            this.componentKey += 1;
          })
          .catch(() => {
            alert(
              "Aconteceu um erro no envio de seu agendamento, Para mais dúvidas, ligue para (11) 3376-0100"
            );
          });
      } finally {
        // this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>
